import React from 'react';
import Flux  from '../../../flux/Flux';

function withMobileViewChange(WrappedComponent) {
    class withMobileViewChange extends React.PureComponent {
        constructor(props) {
            super(props);
            this.state = {
                isMobileView: this.isMobileView(),
            };
            this.onWindowResize = this.onWindowResize.bind(this);
        }

        componentDidMount() {
            Flux.Browser.addWindowResizeListener(this.onWindowResize);
        }

        componentWillUnmount() {
            Flux.Browser.removeWindowResizeListener(this.onWindowResize);
        }

        onWindowResize() {
            this.setState({
                isMobileView: this.isMobileView()
            });
        }

        isMobileView() {
            return Flux.Browser.getWindowSize().width < Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS.sm;
        }

        render() {
            return (<WrappedComponent {...this.state} {...this.props} />);
        }
    }
    return withMobileViewChange;
}

export default withMobileViewChange;
